import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { playgroundProjects } from "../data/portfolio";
import { ProjectCard } from "../components/card";

export default function Playground() {
  return (
    <div className="theme-ink min-h-screen page-x pt-24 pb-24" data-testid="playground-page">
      <Helmet><title>Playground — Poonam Baid | vdesigns.eps</title></Helmet>
      <div className="wrap">
        <p className="mono mb-3" style={{ color: "var(--lime)" }}>(01) PLAYGROUND</p>
        <h1 className="display" style={{ fontSize: "clamp(2.6rem,10vw,9rem)", color: "var(--lime)", overflowWrap: "anywhere" }}>PLAY GROUND</h1>
        <p className="serif mt-3" style={{ fontSize: "clamp(1.1rem,3vw,2.2rem)", color: "#fff" }}>the files that never needed a client — {playgroundProjects.length} experiments.</p>

        {/* 00 · PLAYGROUND SHOWREEL */}
        <section className="reel2 mt-10" id="pg-reel" data-testid="playground-showreel">
          <div className="wrap rhead">
            <span className="mono">(00) The deck — playground showreel</span>
            <span className="mono">Click a chapter · ←/→ to skip · hover to pause · click any work to open its file</span>
          </div>
          <div className="rframe">
            <iframe src="/showreel/playground/index.html?play&base=/work/&ext=" title="Poonam Baid — playground showreel" loading="lazy" allow="autoplay" data-testid="playground-showreel-iframe" />
          </div>
          <div className="wrap rfoot mono">
            <span>PLAYGROUND_2026.EPS · silent</span>
            <a href="/showreel/playground-2026.mp4" target="_blank" rel="noopener">Watch as a video ↗</a>
          </div>
        </section>

        <div style={{ columnGap: 20 }} className="[column-count:1] sm:[column-count:2] lg:[column-count:3] mt-10">
          {playgroundProjects.map((p, idx) => (
            <div key={p.slug} className="mb-6" style={{ breakInside: "avoid" }} data-testid={`play-${p.slug}`}>
              <ProjectCard project={p} eager={idx < 3} dark />
            </div>
          ))}
        </div>

        <div className="rule-t mt-14 pt-8" style={{ borderColor: "rgba(255,255,255,.14)" }}>
          <Link to="/work" className="h2 ul" style={{ fontSize: "clamp(1.4rem,3vw,2.6rem)", color: "#fff" }}>See the client work →</Link>
        </div>
      </div>
    </div>
  );
}
